var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2143 83.9999C68.8735 83.9999 83.9999 68.8735 83.9999 50.2143C83.9999 31.555 68.8735 16.4287 50.2143 16.4287C31.555 16.4287 16.4287 31.555 16.4287 50.2143C16.4287 68.8735 31.555 83.9999 50.2143 83.9999ZM50.2143 87.9999C71.0827 87.9999 87.9999 71.0827 87.9999 50.2143C87.9999 29.3459 71.0827 12.4287 50.2143 12.4287C29.3459 12.4287 12.4287 29.3459 12.4287 50.2143C12.4287 71.0827 29.3459 87.9999 50.2143 87.9999Z",
    fill: "#3156FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 29.5C51.3807 29.5 52.5 30.6193 52.5 32L52.5 54C52.5 55.3807 51.3807 56.5 50 56.5C48.6193 56.5 47.5 55.3807 47.5 54L47.5 32C47.5 30.6193 48.6193 29.5 50 29.5Z",
    fill: "#3156FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 68C53 69.6569 51.6569 71 50 71C48.3431 71 47 69.6569 47 68C47 66.3431 48.3431 65 50 65C51.6569 65 53 66.3431 53 68Z",
    fill: "#3156FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.7e3b95892152db68e897c09ae653ca66.svg";
export { ForwardRef as ReactComponent };